import { RelationshipModel } from "./relationship.model";
import { OrganizationDetailModel } from "./organization-detail.model";

class DashboardModel {
  calls: string;

  constructor(init: any = {}) {
    Object.assign(this, init);
  }
}

export class OrganizationModel {
  uuid: string;
  parent_uuid: string;
  name: string;
  permissions: string[];
  is_active: boolean;
  is_sso: boolean;
  details: OrganizationDetailModel;
  dashboard_pages: DashboardModel;
  relationship: RelationshipModel;
  tts_language: string;
  created: string;
  billing_currency: string;
  number_count: number;
  idle_timeout: number;
  whatsapp_account_count: number;
  has_campaigns: boolean;
  campaign_upload_limit: number;
  // Whether the org is commercially cleared for SIP calling (SD-4314).
  // Read-only, and currently informational: the Phone Users screen is offered
  // to every org, and the API is what refuses writes for one that is not
  // cleared. Kept because it mirrors the payload and the entitlement is real;
  // defaults false so a payload without it never reads as cleared.
  sip_calling_enabled: boolean;

  constructor(init: any = {}) {
    const data = {
      uuid: null,
      parent_uuid: null,
      name: "",
      permissions: [],
      is_active: false,
      is_sso: false,
      relationship: null,
      tts_language: "",
      created: "",
      billing_currency: "",
      number_count: 0,
      idle_timeout: 0,
      whatsapp_account_count: 0,
      has_campaigns: false,
      campaign_upload_limit: 0,
      sip_calling_enabled: false,
      ...init,
    };

    this.uuid = data.uuid;
    this.parent_uuid = data.parent_uuid;
    this.name = data.name;
    // Normalised, not assigned. The `...init` spread above overrides the `[]`
    // default with whatever the key held, so a payload carrying a non-array
    // reaches every consumer that calls `.includes` on it -- and on a STRING
    // that silently becomes a substring match, where "campaign_admin" would
    // satisfy a test for "campaign".
    //
    // `SlugRelatedField(many=True)` over `Group.name` cannot emit either shape
    // today, so this is a guard rather than a fix. It lives here because the
    // model is what promises `string[]` to its callers, and `strict: false`
    // means nothing else checks.
    this.permissions = Array.isArray(data.permissions) ? data.permissions : [];
    this.is_active = data.is_active;
    this.is_sso = data.is_sso;
    this.tts_language = data.tts_language;
    this.number_count = data.number_count;
    this.idle_timeout = data.idle_timeout;
    this.whatsapp_account_count = data.whatsapp_account_count;
    this.has_campaigns = data.has_campaigns;
    this.campaign_upload_limit = data.campaign_upload_limit;
    // Only a real boolean counts. The default is false because this gates a
    // paid capability, and anything else the payload might carry -- a string,
    // a missing key -- should leave the screen off rather than accidentally on.
    this.sip_calling_enabled = data.sip_calling_enabled === true;
    this.created = data.created;
    this.billing_currency = data.billing_currency;
    if (data.details) {
      this.details = new OrganizationDetailModel(data.details);
    }
    if (data.dashboard_pages && Object.keys(data.dashboard_pages).length) {
      this.dashboard_pages = new DashboardModel(data.dashboard_pages);
    }
    if (data.relationship) {
      this.relationship = new RelationshipModel(data.relationship);
    }
  }
}
